import { render } from "./ClassificationFilter.vue?vue&type=template&id=19307dcf&scoped=true"
import script from "./ClassificationFilter.vue?vue&type=script&lang=js"
export * from "./ClassificationFilter.vue?vue&type=script&lang=js"

import "./ClassificationFilter.vue?vue&type=style&index=0&id=19307dcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19307dcf"]])

export default __exports__